
import React, { useCallback, useContext, useEffect, useState } from 'react';
import '../../../../libs/bulma.min.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare } from '@fortawesome/free-solid-svg-icons';

function FormIPInterfaces(props) {
  const { handleChangeValues, inputDisable, queues, endpoints } = props;

  return (
    <div name="change-entrance-div" className="is-align-content-center">
      <div className="columns">
        <div className="column is-2 field mt-2">
          <label className="label">Multiplos Ranges
            <div className="control">
              <div name="only" className="select is-fullwidth">
                <select className="select" name="only" onChange={(e) => handleChangeValues(e.target)} disabled={ inputDisable }>
                  <option value="">Selecione</option>
                  <option value={ true }> Sim </option>
                  <option value={ false }> Não </option>
                </select>
                <p name="only-placeholder-data" className='has-text-grey-dark is-size-7'>Haverá mais de um range de ramal?</p>
                <p name="only-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
              </div>
            </div>
          </label>
        </div>
        <div className="column is-2 field mt-2 my-2">
          <label className="label">Range
            <div className="control">
              <input className="input is-uppercase" name="mask" type="text" placeholder="41XX (4 digitos)" onBlur={(e) => handleChangeValues(e.target)} disabled={ inputDisable } />
              <p name="mask-placeholder-data" className='has-text-grey-dark is-size-7'>Máscara de ramal.</p>
              <p name="mask-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
        <div className="column is-2 field mt-2">
          <label className="label">Tempo
            <div className="control">
              <input className="input" name="timeout" type="number" placeholder="Mín. 5s" onChange={(e) => handleChangeValues(e.target)} disabled={ inputDisable } />
              <p name="timeout-placeholder-data" className='has-text-grey-dark is-size-7'>Duração de toque em segundos.</p>
              <p name="timeout-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos.</p>
            </div>
          </label>
        </div>
        <div className="column is-1 field mt-2">
          <label className="label">Transbordo
            <div className="control">
              <div name="overflow" className="select is-fullwidth">
                <select className="select" name="overflow" onChange={(e) => handleChangeValues(e.target)} disabled={ inputDisable }>
                  <option value="">Selecione</option>
                  <option value="yes"> Sim </option>
                  <option value="no"> Não </option>
                </select>
                <p name="overflow-placeholder-data" className='has-text-grey-dark is-size-7'>Redirecionar.</p>
                <p name="overflow-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
              </div>
            </div>
          </label>
        </div>
      </div>
      <div name="columns-overflow" className="columns is-hidden">
        <div className="column is-2 field mt-2 is-fullwidth is-offset-1">
          <label className="label">Redirecionar
            <div className="control">
              <div name="redirect-overflowData-typeOverFlow" className="select is-fullwidth">
                <select className="select" name="redirect-overflowData-typeOverFlow" onChange={(e) => { 
                  handleChangeValues(e.target)
                  }}
                >
                  <option value="">Selecione</option>
                  <option value="endpoint"> Ramal </option>
                  <option value="queue"> Fila </option>
                  {/* <option value="ura"> URA </option> */}
                </select>
                <p name="redirect-overflowData-typeOverFlow-placeholder-data" className='has-text-grey-dark is-size-7'>Tipo de redirecionamento.</p>
                <p name="redirect-overflowData-typeOverFlow-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
              </div>
            </div>
          </label>
        </div>
        <div id="overflow-queue" className="column is-2 field mt-2 is-hidden">
          <label className="label">Filas
            <div className="control">
              <div className="select is-fullwidth">
                <select className="select" name="redirect-overflowData-destinationOverflow" onChange={(e) => handleChangeValues(e.target)} >
                  <option value="">Selecione</option>
                  { queues.map((queue) => <option key={ 'overflow' + queue } value={ queue }>{ queue }</option>) }
                </select>
                <p name="redirect-overflowData-destinationOverflow-placeholder-data" className='has-text-grey-dark is-size-7'>Encaminha chamadas para uma fila.</p>
                <p name="redirect-overflowData-destinationOverflow-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
              </div>
            </div>
          </label>
        </div>
        <div id="overflow-endpoint" className="column is-2 field mt-2 is-hidden">
          <label className="label">Ramais
            <div className="control">
              <div className="select is-fullwidth">
                <select className="select" name="redirect-overflowData-destinationOverflow" onChange={(e) => handleChangeValues(e.target)} >
                  <option value="">Selecione</option>
                  { endpoints.map((endpoint) => <option key={ 'overflow' + endpoint } value={ endpoint }>{ endpoint }</option>) }
                </select>
                <p name="redirect-overflowData-destinationOverflow-placeholder-data" className='has-text-grey-dark is-size-7'>Redireciona as chamadas ramal.</p>
                <p name="redirect-overflowData-destinationOverflow-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
              </div>
            </div>
          </label>
        </div>
      </div>
      <br/>
    </div>
  );
}

export default FormIPInterfaces;
